export const routes = {
  auth: {
    login: '/auth/login',
    forgetPassword: '/auth/forget-password',
    forgetPasswordSuccess: '/auth/forget-password/success',
    signup: '/auth/sign-up',
  },
  app: {
    dashoard: '/app/dashboard',
    settings: '/app/settings',
  },
  fibonacci: {
    customers: `/app/fibonacci/customers`,
    customersDetail: `/app/fibonacci/customers`,
    transactions: `/app/fibonacci/transactions`,
    transactionDetail: `/app/fibonacci/transactions`,
    overview: `/app/fibonacci/overview`,
    rules: `/app/fibonacci/rules`,
    rulesDetail: `/app/fibonacci/rules`,
    blacklist: `/app/fibonacci/blacklist`,
    blacklistDetail: `/app/fibonacci/blacklist`,
    allOverview: `/app/fibonacci/all-overview`,
    settingsFibonacci: `/app/fibonacci/settings`,
  },
  diana: {
    dianaOverview: '/app/diana/overview',
    dianaConfiguration: '/app/diana/configuration',
    batchHome: '/app/diana/batch',
    batchOnboarding: '/app/batch-onboarding',
    onboardingId: (id: string, projectType: string) =>
      `/app/cre-onboarding/${id}/${projectType === 'CRE' ? 'real-estate' : 'project-financing'}`,
    onboarding: `/app/cre-onboarding`,
    diana: '/app/diana',
    overview: (id: string) => `/app/diana/${id}/overview`,
    creoverview: (id: string) => `/app/cre/${id}/overview`,
    financialAnalysis: (id: string) => `/app/diana/${id}/financial-analysis`,
    crefinancialAnalysis: (id: string) => `/app/cre/${id}/financial-analysis`,
    operationalAnalysis: (id: string) =>
      `/app/diana/${id}/operational-analysis`,
    geospatialAnalysis: (id: string) =>
      `/app/diana/${id}/geospatial-risk-analysis`,
    cregeospatialAnalysis: (id: string) =>
      `/app/cre/${id}/geospatial-risk-analysis`,
    whatIf: (id: string) => `/app/diana/${id}/what-if`,
    riskAnalysis: (id: string) => `/app/diana/${id}/risk-analysis`,
    creriskAnalysis: (id: string) => `/app/cre/${id}/risk-analysis`,
    batchDetail: (id: string) => `/app/diana/batch/${id}`,
    batchDetails: (id: string) => `/app/diana/${id}/batch`,
    batchAnalysis: (id: string) => `/app/${id}/diana-batch-analysis`,
    atlantaEnergy: '/app/atlanta-energy',
    diamondEnergy: '/app/diamond-energy',
    californiaEv1nergy: '/app/california-energy',
    projectFinancing: (id: string) => `${id}/project-financing`,
    dianaProject: '/app/diana/project',
    newInvestmentAnalysis: {
      aboutProperty: (id: string) =>
        `/app/new-investment-analysis/${id}/about-property`,
      developmentPlan: (id: string) =>
        `/app/new-investment-analysis/${id}/development-plan`,
      financingStructure: (id: string) =>
        `/app/new-investment-analysis/${id}/financing-structure`,
      incomeOperatingAssumptions: (id: string) =>
        `/app/new-investment-analysis/${id}/income-operating-assumptions`,
      investmentStructure: (id: string) =>
        `/app/new-investment-analysis/${id}/investment-structure`,
      analysis: (id: string) => `/app/new-investment-analysis/${id}/analysis`,
    },
  },
  cre: {
    investors: {
      overview: `/stakeholder/deal-overview`,
      interactiveReport: `/stakeholder/interactive-report`,
    },

    creOverview: '/app/cre/overview',
    creConfiguration: '/app/cre/configuration',
    batchHome: '/app/cre/batch',
    batchOnboarding: '/app/batch-onboarding',
    onboardingId: (id: string) =>
      `/app/new-investment-analysis/${id}/about-property`,
    onboarding: `/app/diana-onboarding`,
    diana: '/app/cre',
    overview: (id: string) => `/app/cre/${id}/overview`,
    financialAnalysis: (id: string) => `/app/cre/${id}/financial-analysis`,
    documentChecker: (id: string) => `/app/cre/${id}/document-checker`,
    inputAndAssumptions: (id: string) => `/app/cre/${id}/input-and-assumptions`,
    investorRelations: (id: string) => `/app/cre/${id}/stakeholder-relations`,
    operationalAnalysis: (id: string) => `/app/cre/${id}/operational-analysis`,
    geospatialAnalysis: (id: string) =>
      `/app/cre/${id}/geospatial-risk-analysis`,
    whatIf: (id: string) => `/app/cre/${id}/what-if`,
    riskAnalysis: (id: string) => `/app/cre/${id}/risk-analysis`,
    batchDetail: (id: string) => `/app/cre/batch/${id}`,
    batchDetails: (id: string) => `/app/cre/${id}/batch`,
    batchAnalysis: (id: string) => `/app/${id}/diana-batch-analysis`,
    atlantaEnergy: '/app/atlanta-energy',
    diamondEnergy: '/app/diamond-energy',
    californiaEv1nergy: '/app/california-energy',
    projectFinancing: (id: string) => `${id}/project-financing`,
    dianaProject: '/app/cre/project',
    newInvestmentAnalysis: {
      aboutProperty: (id: string) =>
        `/app/new-investment-analysis/${id}/about-property`,
      developmentPlan: (id: string) =>
        `/app/new-investment-analysis/${id}/development-plan`,
      financingStructure: (id: string) =>
        `/app/new-investment-analysis/${id}/financing-structure`,
      incomeOperatingAssumptions: (id: string) =>
        `/app/new-investment-analysis/${id}/income-operating-assumptions`,
      investmentStructure: (id: string) =>
        `/app/new-investment-analysis/${id}/investment-structure`,
      analysis: (id: string) => `/app/new-investment-analysis/${id}/analysis`,
    },
  },
  euclid: {
    overview: '/app/euclid',
  },
} as const;
